export default __webpack_public_path__ + "static/3. Effortlessly track Student Development 2-e7c0cbf37d2f3a1ad65f55cc240c5dfc.jpg";